export default {
    props: ['errorsProp', 'application'],

    data () {
        return {
            isApplicationModalActive: false,
            selectedApplication: null,
            form: {}
        }
    },

    mounted () {
        if (this.application) {
            this.form = _.clone(this.application)
            this.form.type = this.application.numeric_type
        }
    },

    methods: {
        selectApplication (application) {
            this.$emit('application-selected', application)
        },

        openApplicationModal (application) {
            this.isApplicationModalActive = true
            this.selectedApplication = application
        }
    },

    watch: {
        // form: {
        //     immediate: true,
        //     deep: true,
        //     handler () {
        //         this.$emit('input', this.form)
        //     }
        // },

        form:{
            handler (value) {
                this.$emit('update:model-value', value);
            },
            deep: true,
            immediate: true
        },

        errorsProp () {
            this.errors = this.errorsProp
        }
    }
}
